export default "szukaj";